module.exports = __webpack_public_path__ + "img/icon_profile_inactive_mob.54a3d3ea.svg";